export default __webpack_public_path__ + "static/media/image06.25150928.jpg";